import Privileges from "@/utility/UserPrivileges";
import { FolderHierarchy } from "../FolderHierarchy";
import { ClientPrivileges } from "./ClientPrivilegesEnum";

/**Profilo di utenza */
export class ClientProfile {
    /**Nome del profilo */
    name: string = "";

    /**Gruppo Windows associato al profilo */
    windowsGroup: string;

    /**Gruppo legato all'autenticazione tramite plugin */
    authPluginGroup: string;

    /**Diritti */
    privileges: ClientPrivileges;

    /**Lista delle cartelle associate a questo utente */
    associatedHierarchyList: FolderHierarchy[] = [];

    organizationId: number = null;

    get privilegesList(): string[] {
        return Privileges.filter((p) => p.name.and(this.privileges) != ClientPrivileges.None).map((c) => c.name.privilegeName);
    }
    set privilegesList(names: string[]) {
        console.log("set privilegesList", names);
        names.forEach((name) => (this.privileges = this.privileges.or(new ClientPrivileges(name))));
    }

    static parseFrom(data: any): ClientProfile {
        let res = new ClientProfile();
        res.name = data.Name;
        res.windowsGroup = data.WindowsGroup;
        res.authPluginGroup = data.AuthPluginGroup;
        res.privileges = new ClientPrivileges(data.Privileges.PrivilegeName);
        res.associatedHierarchyList = [];
        if (data.AssociatedHierarchyList) {
            data.AssociatedHierarchyList.forEach((c) => {
                res.associatedHierarchyList.push(FolderHierarchy.parseFrom(c));
            });
        }
        if (data.OrganizationId != null) res.organizationId = data.OrganizationId;
        return res;
    }

    clone(): ClientProfile {
        let res = new ClientProfile();
        res.name = this.name;
        res.windowsGroup = this.windowsGroup;
        res.authPluginGroup = this.authPluginGroup;
        res.privileges = this.privileges;
        res.associatedHierarchyList = JSON.parse(JSON.stringify(this.associatedHierarchyList));
        res.organizationId = this.organizationId;
        return res;
    }
}
